import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import styles from "./ApplicationsPage.module.scss";
import { useFetchAcademicYears } from "../../../Hooks/Settings";
import ApplicantDetails from "../../Molecules/detailsBox/applicantDetailsBox";
import TableTopHeader from "../../Molecules/TableTopHeader/ApplicationsTableTopHeader";
import ApplicantsTable from "../../Molecules/Applications/ApplicantsTable";
import { PageTitleContext } from "../../HOC/GeneralBody/GeneralBody";
import {
  useFetchApplicants,
  useExportTableApplicants,
  useFetchSingleApplicant,
} from "../../../Hooks/Applications";

const ApplicationsPage = () => {
  const [Page, setPage] = useState(1);
  const [PageSize, setPageSize] = useState(10);
  const HeaderAttr = useContext(PageTitleContext);
  const [selected, setSelected] = useState("applicants");
  const { data: academicYears } = useFetchAcademicYears();

  const [applicantsNumber, setApplicantsNumber] = useState(0);

  const [applicationId, setApplicationId] = useState("");
  const [moveRight, setMoveRight] = useState(false);

  const [search, setSearch] = useState();
  const [order, setOrder] = useState(["", "asc"]);
  const [mode, setMode] = useState("applicants");
  const [details, setDetails] = useState("");
  const { id } = useParams();
  let componentRef = useRef();

  const applicantsTableHeader = [
    {
      name: "Fullname EN",
      originalName: "fullName_EN",
    },
    {
      name: "Fullname AR",
      originalName: "fullName_AR",
    },
    {
      name: "Email",
      originalName: "email",
    },
    {
      name: "Phone",
      originalName: "phoneNumber",
    },
    {
      name: "Degree Type",
      originalName: "degreeType",
    },
  ];

  const {
    data: applicants,
    refetch: refetchApplicants,
    isLoading: isLoading,
  } = useFetchApplicants({
    pageSize: PageSize,
    pageNumber: Page,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const {
    data: applicantsPrint,
    refetch: refetchApplicantsPrint,
    isLoading: isLoadingApplicantData,
  } = useFetchApplicants({
    pageSize: 10000,
    pageNumber: 1,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const { data: ApplicantbyId, refetch: refetchSingleApplicant } =
    useFetchSingleApplicant(details);
  //---------------------------------exportTables All
  const exportApplicantsTable = useExportTableApplicants();
  const handleExportTable = async () => {
    try {
      var data = await exportApplicantsTable.mutateAsync();

      if (data.data instanceof Blob) {
        const blob = new Blob([data.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "ApplicantsTable";
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        console.error("Unexpected data type. Expected string.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  //-------------------------------------
  useEffect(() => {
    if (details) {
      HeaderAttr.setMoveRight("40px");

      refetchSingleApplicant();
      HeaderAttr.setPathName("Applicant Details");
    } else {
      HeaderAttr.setMoveRight("2px");
      HeaderAttr.setPathName("Applicants");
    }
  }, [details]);

  useEffect(() => {
    refetchApplicants();
  }, [Page, PageSize, search, order]);

  useEffect(() => {
    if (applicants && !applicantsNumber) {
      setApplicantsNumber(applicants && applicants.data.totalCount);
    }
  }, [applicants]);

  useEffect(() => {
    setSearch("");
    setPage(1);
    setPageSize(10);
    setOrder(["", "asc"]);
  }, [selected]);

  return (
    <>
      {!details ? (
        <div className={styles["container"]}>
          <div className={styles["search-container"]}>
            <div className={styles["table-container"]}>
              <TableTopHeader
                rowsCount={applicants}
                mode={mode}
                handleExport={handleExportTable}
                search={search}
                setSearch={setSearch}
                data={applicantsPrint?.data}
                refetch={refetchApplicantsPrint}
                tableHeader={applicantsTableHeader}
                title='Applicants Table'
              />
              <ApplicantsTable
                data={applicants?.data}
                tableHeader={applicantsTableHeader}
                mode={mode}
                page={Page}
                setPage={setPage}
                pageSize={PageSize}
                setPageSize={setPageSize}
                isApplicantsLoading={isLoading}
                setDetails={setDetails}
                setApplicationId={setApplicationId}
                details={details}
                order={order}
                setOrder={setOrder}
                refetch={refetchApplicants}
                setMoveRight={setMoveRight}
                isLoading={isLoadingApplicantData}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <ApplicantDetails
            data={ApplicantbyId && ApplicantbyId.data}
            setDetails={setDetails}
            details={details}
            applicantId={details}
            applicationId={applicationId}
            refetchSingleApplicant={refetchSingleApplicant}
            setMoveRight={setMoveRight}
            moveRight={moveRight}
          />
        </>
      )}
    </>
  );
};

export default ApplicationsPage;
